import { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

interface AppHeaderProps {
  children: ReactNode;
  className?: string;
}

export function AppHeader({ children, className }: AppHeaderProps) {
  return (
    <header className={cn('sticky top-0 z-40 flex h-16 shrink-0 items-center border-b', className)}>
      {children}
    </header>
  );
}
